import React from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import Icon from '../../icons/Icon'
import _ from 'lodash'
import { DialogTitle } from '@mui/material'
import { useJunoCommonFunctions } from '../../../helpers'
import { useSelector } from 'react-redux'
import { constant } from '../../constant'

export default function JncDialogTitleTransaction({ transaction, onClose }) {
    const { getCryptoIcons } = useJunoCommonFunctions()
    const imageBaseUrl = useSelector((state) => state.config.image_base_url)

    const {TRANSACTION_TYPE_CONSTANT: {FIAT: {BULK_PAYMENT}}} = constant;

    return (
        <div>
            {transaction && (
                <DialogTitle id="scroll-dialog-title" className="">
                    <div className="jncTransactionModal">
                        <div className="jncTransactionModal__header">
                            {transaction?.currencyType === 'crypto' ? (
                                getCryptoIcons(transaction.type)
                            ) : transaction?.type == BULK_PAYMENT ? (
                                <div className="svg-block">
                                    <img
                                        src={`${imageBaseUrl}/common/groupIcon.svg`}
                                        alt="Bulk Payment"
                                        className="w-6 h-6"
                                    />
                                </div>
                            ) : (
                                <Icon id={_.camelCase(transaction.type)} />
                            )}
                            {transaction?.type == BULK_PAYMENT ? (
                                <div lassName="jncTransactionModal__title">
                                    Payment Out
                                    <span className="block text-xs text-[#98A2B3]">
                                        via Bulk Upload
                                    </span>
                                </div>
                            ) : (
                                <div className="jncTransactionModal__title">
                                    {transaction.type}
                                </div>
                            )}
                        </div>
                        <button
                            onClick={onClose}
                            type="button"
                            className="jncModal__close"
                        >
                            <ClearIcon />
                        </button>
                    </div>
                </DialogTitle>
            )}
        </div>
    )
}
